"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Image = _interopRequireDefault(require("../../../atoms/Image"));

var _SpecialPriceVariation = _interopRequireDefault(require("./SpecialPriceVariation"));

var _utils = require("../utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SpecialImage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SpecialImage, _React$Component);

  var _super = _createSuper(SpecialImage);

  function SpecialImage() {
    (0, _classCallCheck2["default"])(this, SpecialImage);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(SpecialImage, [{
    key: "renderContent",
    value: function renderContent(item) {
      var _this$props = this.props,
          groupByCategory = _this$props.groupByCategory,
          showImage = _this$props.showImage,
          categories = _this$props.categories,
          precision = _this$props.precision;
      var name = item.name,
          _id = item._id,
          image = item.image,
          _item$gatsbyImage = item.gatsbyImage,
          gatsbyImage = _item$gatsbyImage === void 0 ? {} : _item$gatsbyImage,
          description = item.description,
          variations = item.variations;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "special-container"
      }, showImage && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: image,
        imageQuery: gatsbyImage ? gatsbyImage.childImageSharp : {},
        className: "special-image-carousel-image",
        altText: name
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "special-details"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "special-title"
      }, name), !groupByCategory && /*#__PURE__*/_react["default"].createElement("h4", {
        className: "special-image-category"
      }, (0, _utils.getCategoryNameFromItems)(_id, categories)), /*#__PURE__*/_react["default"].createElement("span", {
        className: "special-description"
      }, description), /*#__PURE__*/_react["default"].createElement(_SpecialPriceVariation["default"], {
        variations: variations,
        precision: precision
      })));
    }
  }, {
    key: "renderWithCategory",
    value: function renderWithCategory() {
      var _this = this;

      var _this$props2 = this.props,
          items = _this$props2.items,
          categories = _this$props2.categories;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        centered: true,
        stackable: true,
        columns: 3
      }, (0, _utils.getCategoryItems)({
        items: items,
        categories: categories
      }).map(function (_ref) {
        var name = _ref.name,
            categoryItems = _ref.items;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: name
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          width: 16,
          textAlign: "center"
        }, /*#__PURE__*/_react["default"].createElement("h3", {
          className: "special-category"
        }, name)), categoryItems.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
            stretched: true
          }, _this.renderContent(item));
        }));
      }));
    }
  }, {
    key: "renderWithoutCategory",
    value: function renderWithoutCategory() {
      var _this2 = this;

      var items = this.props.items;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
        centered: true,
        stackable: true,
        columns: 3
      }, items.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          stretched: true
        }, _this2.renderContent(item));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          groupByCategory = _this$props3.groupByCategory,
          categories = _this$props3.categories;
      return groupByCategory && categories.length ? this.renderWithCategory() : this.renderWithoutCategory();
    }
  }]);
  return SpecialImage;
}(_react["default"].Component);

SpecialImage.propTypes = {
  items: _propTypes["default"].array.isRequired,
  categories: _propTypes["default"].array,
  showImage: _propTypes["default"].bool,
  groupByCategory: _propTypes["default"].bool
};
SpecialImage.defaultProps = {
  categories: [],
  showImage: true,
  groupByCategory: false
};
var _default = SpecialImage;
exports["default"] = _default;